import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { CategoryType } from '../types';

export class Snowplow2StatsAdapterCategory implements StatsAdapterInterface {
  /**
   * Category ID => category string
   */
  protected mapping: { [key: number]: string } = {
    1: 'buy',
    2: 'rent',
    3: 'buy_commercial',
    4: 'rent_commercial',
  };

  /**
   *
   * @param categoryId
   */
  constructor(protected categoryId: number) {}

  /**
   * @inheritDoc
   */
  public getData(): CategoryType {
    // Returns the mapped value or falls back to the original value
    return this.mapping[this.categoryId] || String(this.categoryId);
  }
}
